/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Drivs av Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Drivs av AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Innehållet baseras på dina behörigheter och dess kvalitet kan variera',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Innehållskvaliteten kan variera',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'Använder AI. Verifiera resultat.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Information',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Inkludera kunskap från aktuell sida',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence-logotyp',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Tillbaka',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Avbryt',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Avbryt',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Avbryt',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Dåligt svar',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback skickad',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Bra svar',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Fortsätt från senaste svar',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopiera',
  'fabric.editor.ai.config.item.action.responseCopied': 'Kopierat!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Kopierad till urklipp',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Försök igen',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Vi har problem med att infoga svaret. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Det gick inte att få ett svar. Din uppmaning eller ditt svar överskred gränsen för denna förfrågan. Stäng dialogrutan och försök igen.',
  'fabric.editor.ai.experience.apiError': 'Vi kunde inte få ett svar, försök igen.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    'Innehållet är för kort för att sammanfatta. Lägg till mer och försök igen.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Genererar',
  'fabric.editor.ai.experience.previewScreenLabel': 'Förhandsgranska',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': 'Be agenten att skriva något eller välj nedan',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo-logotyp',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Tillbaka',
  'fabric.editor.ai.screens.discard.discardLabel': 'Kassera',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Varning',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Fel',
  'fabric.editor.ai.screens.error.cancelLabel': 'Avbryt',
  'fabric.editor.ai.screens.error.retryLabel': 'Försök igen',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Innehåll som uppdateras live:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Genererar ikon',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Åtgärder för AI-genererat innehåll',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Avbryt',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Berätta för AI vad som ska göras härnäst',
  'fabric.editor.ai.screens.preview.discardLabel': 'Kassera',
  'fabric.editor.ai.screens.preview.disclaimer': 'Informationskvaliteten kan variera.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Ta reda på varför',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Rensa',
  'fabric.editor.ai.screens.preview.header.edit': 'Redigera uppmaning',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Redigera',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Fråga {agentName} vad du ska göra härnäst',
  'fabric.editor.ai.screens.preview.refineButton': 'Förfina',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Förfina',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence-logotyp',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Skicka',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Skicka till AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} – vald',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Ta bort',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Förslag',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Skrivassistent',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Låt Atlassian Intelligence hjälpa dig att skriva',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Skriva',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NYTT',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Säg till AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Fråga agenten',
};
